import { Link } from "react-router-dom";
import { Building2, Mail, Phone, MapPin, Calendar, Youtube } from "lucide-react";
import { BRAND } from "../lib/brandConfig";

// Custom social icons
const TikTokIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const XIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { name: "TikTok", url: "https://www.tiktok.com/@urbannestquest", icon: TikTokIcon },
    { name: "Instagram", url: "https://www.instagram.com/urbannestquest/", icon: InstagramIcon },
    { name: "Facebook", url: "https://www.facebook.com/UrbanNestQuest/", icon: FacebookIcon },
    { name: "LinkedIn", url: "https://www.linkedin.com/company/urban-nest-quest", icon: LinkedInIcon },
    { name: "YouTube", url: "https://www.youtube.com/@Urbannestquest", icon: Youtube },
    { name: "X", url: "https://x.com/urbannest_tx", icon: XIcon },
  ];

  return (
    <footer className="bg-[#1F2A44] text-white" data-testid="site-footer">
      <div className="container-main py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3" data-testid="footer-logo">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                <Building2 className="w-5 h-5 text-[#1F2A44]" />
              </div>
              <div className="leading-tight">
                <div className="font-bold text-xl font-['Playfair_Display']">
                  {BRAND.name}
                </div>
                <div className="text-[10px] uppercase tracking-widest text-[#C8A96B] font-semibold">
                  {BRAND.brokerageLine}
                </div>
              </div>
            </Link>
            <p className="text-white/70 text-sm leading-relaxed">
              Houston apartment locating and relocation support for renters, families, professionals, and people moving to the Houston area.
            </p>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/50 hover:text-[#C8A96B] transition-colors"
                  data-testid={`social-${social.name.toLowerCase()}`}
                  title={social.name}
                >
                  <social.icon />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 font-['Playfair_Display']">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/apartment-search"    className="text-white/70 hover:text-[#C8A96B] transition-colors" data-testid="footer-search">Apartment Search</Link></li>
              <li><Link to="/luxury-apartments"   className="text-white/70 hover:text-[#C8A96B] transition-colors" data-testid="footer-luxury">Luxury Apartments</Link></li>
              <li><Link to="/homes-for-rent"      className="text-white/70 hover:text-[#C8A96B] transition-colors" data-testid="footer-homes">Homes for Rent</Link></li>
              <li><Link to="/relocation-services" className="text-white/70 hover:text-[#C8A96B] transition-colors" data-testid="footer-relocation">Relocation Services</Link></li>
              <li><Link to="/blog"                 className="text-white/70 hover:text-[#C8A96B] transition-colors" data-testid="footer-blog">Houston Blog</Link></li>
              <li><Link to="/neighborhoods"       className="text-white/70 hover:text-[#C8A96B] transition-colors" data-testid="footer-neighborhoods">Neighborhood Guides</Link></li>
              <li><Link to="/specials"            className="text-white/70 hover:text-[#C8A96B] transition-colors" data-testid="footer-specials">Hidden Specials</Link></li>
              <li>
                <a href="/book" target="_blank" rel="noopener noreferrer"
                   className="text-white/70 hover:text-[#C8A96B] transition-colors flex items-center"
                   data-testid="footer-calendly">
                  <Calendar className="w-3 h-3 mr-1" /> Book Consultation
                </a>
              </li>
            </ul>
          </div>

          {/* Areas We Serve */}
          <div>
            <h4 className="font-semibold mb-4 font-['Playfair_Display']">Areas We Serve</h4>
            <ul className="space-y-3 text-sm text-white/70">
              {["Houston", "Katy", "Sugar Land", "The Woodlands", "Conroe", "Energy Corridor", "Downtown"].map((area) => (
                <li key={area} className="flex items-center space-x-2">
                  <MapPin className="w-4 h-4 text-[#C8A96B]" />
                  <span>{area}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 font-['Playfair_Display']">Contact Us</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-[#C8A96B]" />
                <a href={BRAND.emailHref} className="hover:text-[#C8A96B] transition-colors">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-[#C8A96B]" />
                <a href={BRAND.phoneHref} className="hover:text-[#C8A96B] transition-colors">
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-[#C8A96B] mt-0.5" />
                <span>Houston, TX</span>
              </li>
            </ul>
            <a
              href="/book"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center px-4 py-2 bg-[#C8A96B] rounded-lg text-white text-sm font-bold hover:bg-[#B5915A] transition-colors"
              data-testid="footer-book-call"
            >
              <Calendar className="w-4 h-4 mr-2" />
              Book Free Call
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/15 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-white/50">
          <p>&copy; {currentYear} {BRAND.name}. All rights reserved. {BRAND.brokerageLine}.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-[#C8A96B] transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-[#C8A96B] transition-colors">Terms of Service</a>
          </div>
        </div>
        <div className="mt-4 flex flex-col md:flex-row justify-center items-center gap-2 md:gap-6 text-xs text-white/50" data-testid="footer-trec-disclosures">
          <a href={BRAND.trecIabsUrl} target="_blank" rel="noopener noreferrer"
             className="hover:text-[#C8A96B] underline underline-offset-2 transition-colors" data-testid="footer-trec-iabs">
            TREC Information About Brokerage Services
          </a>
          <a href={BRAND.trecCpnUrl} target="_blank" rel="noopener noreferrer"
             className="hover:text-[#C8A96B] underline underline-offset-2 transition-colors" data-testid="footer-trec-cpn">
            TREC Consumer Protection Notice
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
